export default __webpack_public_path__ + "static/media/icons-add.f278563c.svg";